<template>
  <div class="w-full">
    <div class="w-full flex justify-center items-center">
      <ListSelect
        multiple
        class="keycaps-select select-deselect-full w-full max-w-md mb-2 mr-2"
        :clearable="false"
        placeholder="Add keys"
        :options="keycodeOptions"
        :modelValue="keycodes"
        @update:modelValue="(kc: KeyCode[]) => $emit('newKeycodes', kc)"
      />

      <div
        class="tooltip focus-within:tooltip-open transition-colors duration-200"
        :class="captureEnabled ? 'tooltip-accent' : ''"
        :data-tip="
          captureEnabled
            ? 'Now press desired keys on keyboard, click outside to finish'
            : 'Click to enter from keyboard'
        "
      >
        <div
          ref="keyCapture"
          tabindex="-1"
          class="px-2 btn btn-sm btn-ghost focus:bg-accent"
          @focus="captureEnabled = true"
          @blur="captureEnabled = false"
        >
          <Icon icon="material-symbols:keyboard-alt-outline" />
        </div>
      </div>
    </div>

    <ActionList
      :modelValue="actions"
      @update:modelValue="(a: NonKeycodeAction[]) => $emit('newActions', a)"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { KeyCode, NonKeycodeAction } from "@/keyboard";
import { useCaptureKeys } from "@/composables";
import ListSelect from "@/components/utils/ListSelect.vue";
import ActionList from "@/components/actions/ActionList.vue";

defineProps<{
  keycodes: KeyCode[];
  keycodeOptions: KeyCode[];
  actions: NonKeycodeAction[];
}>();

const emit = defineEmits<{
  (_e: "newKeycodes", _value: KeyCode[]): void;
  (_e: "newActions", _value: NonKeycodeAction[]): void;
}>();

const keyCapture = ref<HTMLElement | null>(null);
const capturedKeycodes = useCaptureKeys(keyCapture);
const captureEnabled = ref(false);

watch(capturedKeycodes.value, () => {
  if (captureEnabled.value)
    emit("newKeycodes", Array.from(capturedKeycodes.value));
});
</script>

<style>
.keycaps-select .vs__selected {
  @apply kbd kbd-sm px-2 text-base-content;
}
</style>
